const TOKEN_KEY = "TOKEN_KEY";

// Remove token and log out user
export const logout = () => {
    try {
        localStorage.removeItem(TOKEN_KEY);
        window.location = '/';
    } catch (err) {
        console.error("Logout failed:", err);
    }
};

// Get stored token
export const getToken = () => {
    try {
        const token = localStorage.getItem(TOKEN_KEY);
        return token && token !== "undefined" ? token : null;
    } catch (err) {
        console.error("Error reading token:", err);
        logout();
        return null;
    }
};

// Decode JWT
const parseJwt = (token) => {
    try {
        const base64Url = token.split(".")[1];
        if (!base64Url) throw new Error("Malformed token");

        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
                .join("")
        );
        return JSON.parse(jsonPayload);
    } catch (err) {
        console.error("Failed to decode JWT:", err);
        logout();
        return null;
    }
};

// Check auth status
export const isAuthenticated = () => {
    const token = getToken();
    if (!token) return false;
    const payload = parseJwt(token);
    if (!payload || !payload.exp) return false;
    return payload.exp * 1000 > Date.now();
};

// Optional: Get decoded user info
export const getUserInfo = () => {
    const token = getToken();
    return token ? parseJwt(token) : null;
};
